<!-- Dialog title -->
<div mat-dialog-title>
  <div class="error-popup-header d-flex justify-content-end">
    <img
      src="assets/icon/cross.svg"
      (click)="onClose()"
      class="cursor-pointer"
      alt="close"
    />
  </div>
</div>
<!-- Dialog content -->
<div>
  <div class="row">
    <div class="col-12 text-center">
      <div class="error-gif">
        <img src="assets/gif/error.gif" class="error-gif-image" alt="close" />
        <!-- <p class="text-orange gif-icon-text">Lorem Ipsum</p> -->
      </div>
    </div>
    <div class="col-12">
      <p class="text-content text-center">Attention</p>
    </div>
    <div class="col-12 d-flex justify-content-center">
      <div class="me-1">
        <p class="text-content">
          The provided CKYC details are not sufficient, Click below to complete
          your CKYC
        </p>
      </div>
    </div>
    <div class="col-12 d-flex justify-content-center">
      <button
        class="submit-btn success-submission"
        (click)="shareLink(link)"
        type="submit"
      >
        Procced
      </button>
    </div>
  </div>
</div>
